import Paper, { PaperProps } from 'app/components/base/Paper'

const ColumnContainer: RFC<PaperProps> = ({ children, sx }) => (
  <Paper
    sx={{ flexGrow: 1, flexShrink: 1, flexBasis: 317, ...sx }}
    style={{ padding: 16 }}
  >
    {children}
  </Paper>
)
export default ColumnContainer
